import React from 'react';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver';
import s from './GenericTable.scss';
import ReadMoreLess from '../ReadMoreLess/ReadMoreLess';
import Link from '../../../components/Link/Link';
import { TOI_LIVE_DOMAIN } from '../../../constants';

const GenericTable = ({
  columns = [], // Array of objects defining column properties
  headerTitle,
  tableSubHeading,
  data = [], // Array of objects defining row data
  ga4Type,
  tableClass = '',
  fixedHeader = false,
  fixedFirstColumn = false,
  firstColumnDark = false,
  xAxisScrollable = false,
  tableCellNoWrap = false,
  firstColumnMinWidth130 = false,
  firstColumnSerialNumbers = false,
  firstColumnWidth275 = false,
  isNoHoliday,
  firstRowDark = false,
  hideTableHeader = false,
  customHeader = '',
  isLinked = false,
  ColumnWidth50Percent = false,
  isGold = false,
  metal,
  isIplPointsTable = false,
  tournamentName,
}) => {
  const onView = () => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: `${ga4Type}`,
      });
    }
  };

  const renderCellContent = (col, row) => {
    const value = row[col?.key];
    if (typeof value === 'boolean') {
      return (
        <span title={!value ? 'Open' : 'Closed'}>
          <span className={!value ? s.ticketGreen : s.ticketRed}>
            {!value ? '✔' : '❌'}
          </span>
          {!value ? ' Open' : ' Closed'}
        </span>
      );
    }
    if (
      (col &&
        isGold &&
        (col.key === 'gold22' || col.key === 'todayPriceData')) ||
      col.key === 'pergram22' ||
      col.key === 'pergram24'
    ) {
      let className;

      if (row[col.key] && row[col.key]?.deviationFromLastPrice) {
        if (row[col.key]?.deviationFromLastPrice > 0) {
          className = `plus`;
        } else if (row[col.key]?.deviationFromLastPrice === '0') {
          className = `zero`;
        } else {
          className = `minus`;
        }
      } else {
        className = `${s[col.className]}`;
      }
      return (
        <>
          <span>{row[col.key].todayPrice?.toLocaleString('en-IN')}</span>
          <span className={`deviationArrow ${className}`}>
            {row[col.key]?.deviationFromLastPrice !== undefined &&
              `₹ ${row[col.key]?.deviationFromLastPrice?.toLocaleString(
                'en-IN',
              )}`}
          </span>
        </>
      );
    } else if (col && isGold && col.key === 'city') {
      return (
        <Link
          to={`${TOI_LIVE_DOMAIN}/business/${metal}-rates-today/${metal}-price-in-${row[
            col.key
          ].toLowerCase()}`}
        >
          {row[col.key]}
        </Link>
      );
    } else if (
      isGold &&
      col.key !== 'city' &&
      col.key !== 'name' &&
      col.key !== 'goldrate' &&
      col.key !== 'date'
    ) {
      return <span> {row[col.key]?.toLocaleString('en-IN')}</span>;
    }
    if (col.key === 'name' && isLinked) {
      return (
        <Link
          to={`${TOI_LIVE_DOMAIN}/sports/cricket/${tournamentName ||
            'ipl'}/player-stats/${row[col.key]
            ?.split(' ')
            .join('-')
            .toLowerCase()}/${row.id}`}
        >
          {row[col.key]}
        </Link>
      );
    }
    if (col.key === 'result' && isIplPointsTable) {
      return (
        <Link to={row?.matchLink} className={s.LinkArrow}>
          {row?.result} {row?.result && <i className={s.rightArrow} />}
        </Link>
      );
    }
    if (
      !col ||
      !isLinked ||
      (col.key !== 'name' && col.key !== 'result' && isIplPointsTable)
    ) {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html:
              row[col.key] !== undefined &&
              row[col.key] !== null &&
              row[col.key] !== '-'
                ? row[col.key]
                : '-',
          }}
        />
      );
    }

    return (
      <span
        dangerouslySetInnerHTML={{
          __html:
            row[col.key] !== undefined &&
            row[col.key] !== null &&
            row[col.key] !== '-'
              ? row[col.key]
              : '-',
        }}
      />
    );
  };

  return (
    <InViewObserver inViewCallback={onView}>
      <div className={`${tableClass}`}>
        {headerTitle && <h3 className={s.tableHeading}>{headerTitle}</h3>}
        {tableSubHeading && (
          <ReadMoreLess
            information={tableSubHeading}
            readMoreLengthLimit={270}
            ga4Type={ga4Type}
            ga4Params={
              !!ga4Type && {
                event: 'user_click',
                type: ga4Type,
              }
            }
          />
        )}
        {data &&
          data?.length > 0 && (
            <div
              className={`${s.tableWrapper} ${
                fixedHeader ? s.fixedHeader : ''
              } ${fixedFirstColumn ? s.fixedFirstColumn : ''}  ${
                firstColumnDark ? s.firstColumnDark : ''
              } ${xAxisScrollable ? s.xAxisScrollable : ''} ${
                tableCellNoWrap ? s.tableCellNoWrap : ''
              } ${firstColumnMinWidth130 ? s.firstColumnMinWidth130 : ''}
              ${firstColumnSerialNumbers ? s.firstColumnSerialNumbers : ''}
              ${ColumnWidth50Percent ? s.ColumnWidth50Percent : ''}
              ${firstColumnWidth275 ? s.firstColumnWidth275 : ''} ${
                firstRowDark ? s.firstRowDark : ''
              }  `}
            >
              <div className={s.table}>
                {!hideTableHeader && (
                  <div className={s.tableHeadGroup}>
                    <div className={s.tableRow}>
                      {columns.map((col, index) => (
                        <div
                          key={index}
                          className={col.className || s.tableCell}
                          style={col.style || {}}
                        >
                          {col.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {customHeader && (
                  <div className={s.tableRowGroup}>
                    <div className={`${s.tableRow} ${s.tableRowDark}`}>
                      <div className={s.tableCell}>{customHeader}</div>
                    </div>
                  </div>
                )}
                <div
                  className={`${s.tableRowGroup} ${
                    isNoHoliday ? s.isNoHoliday : ''
                  }    `}
                >
                  {data?.map((row, rowIndex) => {
                    let isKeyChanged = false;

                    if (rowIndex > 0) {
                      if (data[rowIndex].month !== data[rowIndex - 1].month) {
                        isKeyChanged = true;
                      }
                    }

                    let rowClass = s.tableRow;
                    if (rowIndex === 0 && firstRowDark) {
                      rowClass += ` ${s.firstRowBlue}`;
                    }

                    const rowStyle = {};
                    if (isKeyChanged) {
                      rowStyle.borderTop = ''; // You can set your desired border style here
                    }

                    return (
                      <div
                        key={row?.id || rowIndex}
                        style={rowStyle}
                        className={rowClass}
                      >
                        {columns.map((col, colIndex) => (
                          <div
                            key={colIndex}
                            className={col.className || s.tableCell}
                            style={col.style || {}}
                          >
                            {renderCellContent(col, row)}
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
      </div>
    </InViewObserver>
  );
};
export default GenericTable;
